import React from "react";
import { Routes, Route } from "react-router-dom";

import NotFound from "pages/not-found";
import ApplicantDetails from "./details";
import ApplicantsIndex from "./list";
import ApplicantsNew from "./new";

const Applicants: React.FC = () => (
  <Routes>
    <Route index element={<ApplicantsIndex />} />
    <Route path="new" element={<ApplicantsNew />} />
    <Route path=":id" element={<ApplicantDetails />} />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default Applicants;
